import { createRouter, createWebHistory } from 'vue-router'
import { beforeEach, afterEach } from '@/routers/request'

const routes = [

    { name: 'pg',               path: '/:pg', component: () => import('@/layouts/default.vue') },
    { name: 'pg_1',             path: '/:pg/:get_1', component: () => import('@/layouts/default.vue') },
    { name: 'pg_2',             path: '/:pg/:get_1/:get_2', component: () => import('@/layouts/default.vue') },
    { name: 'pg_3',             path: '/:pg/:get_1/:get_2/:get_3', component: () => import('@/layouts/default.vue') },
    { name: 'pg_4',             path: '/:pg/:get_1/:get_2/:get_3/:get_4', component: () => import('@/layouts/default.vue') },


    // DASHBOARD
        { name: 'dashboard',               path: '/dashboard', component: () => import('@/layouts/dashboard.vue') },
        { name: 'dashboard_1',             path: '/dashboard/:get_1', component: () => import('@/layouts/dashboard.vue') },
        { name: 'dashboard_2',             path: '/dashboard/:get_1/:get_2', component: () => import('@/layouts/dashboard.vue') },
        { name: 'dashboard_3',             path: '/dashboard/:get_1/:get_2/:get_3', component: () => import('@/layouts/dashboard.vue') },
        { name: 'dashboard_4',             path: '/dashboard/:get_1/:get_2/:get_3/:get_4', component: () => import('@/layouts/dashboard.vue') },
    // DASHBOARD


    // APP
        { name: 'home',         path: '/index.html', component: () => import('@/layouts/default.vue') },
        { name: 'home',         path: '/app/www/index.html', component: () => import('@/layouts/default.vue') },
    // APP

    { name: 'home',             path: '/', component: () => import('@/layouts/default.vue') },

]

const router = createRouter({
    history: createWebHistory($_GLOBAL.DIR),
    routes,
    base: $_GLOBAL.DIR,
    scrollBehavior(to, from, savedPosition) {
        return { top: 0 }
    },
})

router.beforeEach(beforeEach);
router.afterEach(afterEach);

export default router
